<template>
  <div id="app">
    <Loader/>
    <router-view/>
  </div>
</template>

<script>
import Loader from "@/components/layout/Loader";

export default {
  beforeMount() {
    this.refreshState();
  },
  components: {Loader},
  computed: {
    loading() {
      return this.$store.getters.getLoadingState;
    }
  },
  methods: {
    refreshState() {
      this.requestNotificationPermission();
      return this.$store.dispatch(`refreshState`);
    },
    requestNotificationPermission() {
      if ('Notification' in window) {
        Notification.requestPermission().then(permission => {
          if (permission === "granted") {
            console.log("Notification permission granted.");
          } else {
            console.log("Notification permission denied.");
          }
        }).catch(err => {
          console.error("Failed to get notification permission:", err);
        });
      }
    }
  }
}
</script>
<style lang="scss">
@import "assets/css/styles";

#app {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: auto;
}
</style>
